export default {
  clientId: 'e7de8a75-62bb-43eb-9063-38509f8c21af',
  redirectUri: 'https://genesyscloudblueprints.github.io/agent-monitoring-app-blueprint/'
}
